export const environment = { production: false, apiUrl: 'https://api.perspectives.art/api/v1', };
